<template>
    <div class="question">
        <div v-html="answer"></div>
    </div>
</template>

<script>
    import orderAction from "./index";
    export default {
        name: "h5",
        data(){
            return {
                answer:'',
            }
        },
        mounted() {
            let param = {
                docId:this.$route.query.docId,
                userId:this.$route.query.userId,
            }
            orderAction.getRobotDoc(param,(data)=>{
                this.answer = data;
            })

            document.querySelector(".question").onclick = function (e) {
                console.log(e)
                const link = e.target.getAttribute("data-link");
                if (link) {
                    window.open(link);
                }
            };
        },
        methods:{

        }
    }
</script>

<style scoped>
    .question{
        padding: 10px;
    }
    .question img,.question audio,.question div{
        max-width: 100%;
    }

    span[data-w-e-type="attachment"] {
        color: #4988f8;
        cursor: pointer;
        text-decoration: underline;
    }

</style>



// WEBPACK FOOTER //
// src/components/question/pc.vue